import axios from "@axios";

export default {
  namespaced: true,
  state: {
    data: null,
  },
  getters: {
    getData(state) {
      return state.data;
    },
  },
  mutations: {
    setData(state, value) {
      state.data = value;
    },
  },
  actions: {
    async get({ commit }) {
      const { data } = await axios.get("v1/body-worn/overview");

      if (!data.success) {
        return null;
      }

      commit("setData", data.data);
      return data.data;
    },
  },
};
